import { render, staticRenderFns } from "./SSwitch.vue?vue&type=template&id=52c95ea4&"
import script from "./SSwitch.vue?vue&type=script&lang=js&"
export * from "./SSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports